<template>
  <div class="authorization-form">
    <authorization-layout>
      <h1 class="authorization-form__header">
        Ustaw hasło
      </h1>

      <p class="authorization-form__info">
        Wprowadź nowe hasło a następnie potwierdź zmianę.
      </p>

      <v-form
        ref="resetForm"
        v-model="isFormValid"
        class="mt-3"
        lazy-validation
        @submit.prevent="submitForm"
      >
        <div class="authorization-form__label">
          Nowe hasło
        </div>

        <v-text-field
          v-model.trim="user.password"
          class="authorization-form__field"
          :rules="[rules.required, rules.password]"
          v-bind="props.validatedField"
          type="password"
          placeholder="Wprowadź nowe hasło..."
        />

        <div class="authorization-form__label">
          Powtórz nowe hasło
        </div>

        <v-text-field
          v-model.trim="user.matchingPassword"
          class="authorization-form__field"
          :rules="[rules.required, rules.match(user.password)]"
          v-bind="props.validatedField"
          type="password"
          placeholder="Powtórz hasło..."
        />

        <v-btn
          class="custom-submit-button mt-5"
          color="primary"
          block
          :loading="isLoading"
          type="submit"
          depressed
          height="40"
        >
          Zmień hasło
        </v-btn>
      </v-form>
    </authorization-layout>
  </div>
</template>

<script>
import AuthorizationLayout from '@/components/Layout/AuthorizationLayout.vue';
import validationRules from '@/helpers/validators';
import props from '@/helpers/componentsProps';
import { mapState, mapActions } from 'vuex';

export default {
  components: {
    AuthorizationLayout,
  },

  data() {
    return {
      rules: validationRules,
      props,
      isFormValid: true,
      user: {
        password: '',
        matchingPassword: '',
      },
    };
  },

  computed: {
    ...mapState([
      'isLoading',
    ]),
  },

  methods: {
    submitForm() {
      this.$refs.resetForm.validate();
      if (this.isFormValid) {
        const { token } = this.$route.params;
        const resetParams = {
          password: this.user.password,
          passwordToken: token,
        };
        this.setPassword(resetParams);
      }
    },
    ...mapActions('auth', [
      'setPassword',
    ]),
  },
};
</script>
